import { base62ToHex, hexToBase62, } from '@streamr/tv-engine';
import { toUserId } from '@streamr/utils';
import { matchPath } from 'react-router';
import { formFullStreamId, formShortStreamId } from './streamId';
// Base62 drops the leading zero bytes of a value, so the links are decoded
// to the known lengths of the fields.
const AES_KEY_BYTE_LENGTH = 32;
const BROADCASTER_USER_ID_BYTE_LENGTH = 33; // compressed P-256 public key
export function formBroadcastPath(broadcast, basePath = '/stream') {
    return (`${basePath}/${encodeURIComponent(formShortStreamId(broadcast.streamId))}` +
        `?title=${encodeURIComponent(broadcast.name)}` +
        `&broadcasterUserId=${hexToBase62(broadcast.broadcasterUserId)}` +
        `&startTime=${broadcast.startsAt}` +
        `#aesKey=${hexToBase62(broadcast.aesKey)}`);
}
export function formBroadcastUrl(broadcast, basePath = '/stream') {
    return formPageUrl(formBroadcastPath(broadcast, basePath));
}
export function parseBroadcastFromUrl(url) {
    const match = matchPath('/stream/:streamId', url.pathname) ??
        matchPath('/recordings/:streamId', url.pathname) ??
        matchPath('/embed/:streamId', url.pathname);
    if (match?.params.streamId !== undefined) {
        const streamId = formFullStreamId(match.params.streamId);
        const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
        const name = url.searchParams.get('title'); // TODO the name and title refer to same thing, which is the preferred term?
        const startsAtAsString = url.searchParams.get('startTime');
        const encodedBroadcasterUserId = url.searchParams.get('broadcasterUserId');
        const encodedAesKey = hashParams.get('aesKey');
        if (name == null ||
            startsAtAsString === null ||
            encodedBroadcasterUserId === null ||
            encodedAesKey === null) {
            throw new Error('Invalid url');
        }
        const aesKey = base62ToHex(encodedAesKey, false, AES_KEY_BYTE_LENGTH);
        const broadcasterUserId = toUserId(base62ToHex(encodedBroadcasterUserId, true, BROADCASTER_USER_ID_BYTE_LENGTH));
        return {
            streamId,
            name,
            startsAt: Number(startsAtAsString),
            broadcasterUserId,
            aesKey,
        };
    }
    return undefined;
}
export function formPageUrl(path) {
    const url = new URL(path, window.location.toString());
    return url.toString();
}
